import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  typography: {
    body1: {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 400,
      fontSize: '15px',
      lineHeight: '24px',
      letterSpacing: '0.15px',
    },
    body2: {
      fontFamily: 'ESBuild, sans-serif',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '15.12px',
    },
    body3: {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 400,
      fontSize: '13px',
      lineHeight: '18.2px',
      letterSpacing: '0.17px',
    },
    subtitle1: {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 500,
      fontSize: '15px',
      lineHeight: '24px',
      letterSpacing: '0.15px',
    },
    subtitle2: {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 500,
      fontSize: '13px',
      lineHeight: '20.41px',
      letterSpacing: '0.1px',
    },
    caption: {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 400,
      fontSize: '12px',
      lineHeight: '19.2px',
    },
    overline: {
      fontFamily: 'Poppins, sans-serif',
      fontWeight: 400,
      fontSize: '11px',
      lineHeight: '17.6px',
      letterSpacing: '1px',
    },
    strikethrough1: {
      fontFamily: 'ESBuild, sans-serif',
      fontWeight: 400,
      fontSize: '14px',
      lineHeight: '22.4px',
      letterSpacing: '0.15px',
      textDecoration: 'line-through',
    },
    strikethrough2: {
      fontFamily: 'ESBuild, sans-serif',
      fontWeight: 500,
      fontSize: '12px',
      lineHeight: '16.8px',
      textDecoration: 'line-through',
    },
    h1: {
      fontFamily: 'ESBuild, sans-serif',
      fontWeight: 500,
      fontSize: '96px',
      lineHeight: '112.03px',
      letterSpacing: '-1.5px',
    },
    h2: {
      fontFamily: 'ESBuild, sans-serif',
      fontWeight: 400,
      fontSize: '60px',
      lineHeight: '72px',
      letterSpacing: '-0.5px',
    },
    h3: {
      fontFamily: 'ESBuild, sans-serif',
      fontWeight: 400,
      fontSize: '48px',
      lineHeight: '56.02px',
    },
    h4: {
      fontFamily: 'ESBuild, sans-serif',
      fontWeight: 400,
      fontSize: '34px',
      lineHeight: '44.2px',
      letterSpacing: '0.25px',
    },
    h5: {
      fontFamily: 'ESBuild, sans-serif',
      fontWeight: 700,
      fontSize: '24px',
      lineHeight: '32.02px',
    },
    h6: {
      fontFamily: 'ESBuild, sans-serif',
      fontWeight: 500,
      fontSize: '24px',
      lineHeight: '32.02px',
      letterSpacing: '0.15px',
    },
    h7: {
      fontFamily: 'ESBuild, sans-serif',
      fontWeight: 400,
      fontSize: '19px',
      lineHeight: '20.52px',
    },
    h8: {
      fontFamily: 'ESBuild, sans-serif',
      fontWeight: 400,
      fontSize: '18px',
      lineHeight: '19.44px',
    },
    price: {
      fontFamily: 'ESBuild, sans-serif',
      fontWeight: 500,
      fontSize: '16px',
      lineHeight: '17.28px',
    },
  },
});

export default theme;

declare module '@mui/material/styles' {
  interface TypographyVariants {
    body3: React.CSSProperties;
    h7: React.CSSProperties;
    h8: React.CSSProperties;
    strikethrough1: React.CSSProperties;
    strikethrough2: React.CSSProperties;
    price: React.CSSProperties;
  }

  interface TypographyVariantsOptions {
    body3: React.CSSProperties;
    h7: React.CSSProperties;
    h8: React.CSSProperties;
    strikethrough1: React.CSSProperties;
    strikethrough2: React.CSSProperties;
    price: React.CSSProperties;
  }
}

declare module '@mui/material/Typography' {
  interface TypographyPropsVariantOverrides {
    body3: true;
    h7: true;
    h8: true;
    strikethrough1: true;
    strikethrough2: true;
    price: true;
  }
}
